export default "__VITE_ASSET__DmzY7hRk__";